PJQ.views.budget.BudgetsViewsEditorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-view-editor'),
        subTemplates: {
            columns: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'column-editor-columns'),
            columnEditorEmpty: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-column-editor-empty')
        },
        maxWidth: '900',
        maxHeight: '600',
        onSave: null,
        onDelete: null
    },
    events: {
        'click .btn-create-view': 'createView',
        'click .budget-view-option': 'changeTemplate',
        'click .btn-return': 'viewBudgetViews',
        'click .btn-save': 'saveView',
        'click .btn-edit-columns': 'configureColumns',
        'click .btn-cancel': 'cancelColumnEdit',
        'click .budget-view-column': 'editColumnClicked',
        'click .btn-delete-column': 'deleteColumn',
        'click .create-source': 'createSourceColumn',
        'click .create-calculated': 'createCalculatedColumn',
        'click .edit-view': 'editViewClicked',
        'click .delete-view': 'deleteViewClicked',
        'click .set-default-view': 'defaultViewClicked'
    },
    modes: {
        CREATE: 'CREATE',
        EDIT: 'EDIT',
        VIEW: 'VIEW'
    },
    beforeModalCreated: function () {
        let blankView = new PJQ.models.budget.BudgetView({
            name: "Blank View",
            description: 'Blank view with minimum amount of columns.',
            companyId: -1,
            columns: []
        });

        this.budgetViews = new PJQ.collections.budget.BudgetViews();
        this.mode = this.options.mode ? this.options.mode : this.modes.VIEW;
        if (!this.budgetViews.isFetched) {
            this.budgetViews.fetch({
                success: _.bind(function () {
                    this.budgetViews.add(blankView);
                    this.render();
                }, this)
            })
        } else {
            this.render();
        }
    },
    renderData: function () {
        return {
            budgetViews: this.budgetViews,
            budgetView: this.budgetView,
            mode: this.mode,
            modes: this.modes,
            template: this.template
        }
    },
    afterRender: function () {
        new PJQ.Binder(this.$el, this.budgetView, {
            watchElements: [
                'input'
            ]
        });

        if (this.mode === this.modes.VIEW) {
            this.renderViewMode();
        } else if (this.mode === this.modes.EDIT) {
            this.renderEditMode();
        } else if (this.mode === this.modes.CREATE) {
            this.renderCreateMode();
        }
    },
    renderEditMode: function () {
        this.renderColumns();
        this.renderColumnConfiguration()
    },
    renderCreateMode: function () {
        this.templateColumnTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.views-columns-table'),
            data: this.template.get('columns'),
            rowId: "cid",
            isHideSearch: true,
            paging: false,
            order: [0, 'asc'],
            language: {
                zeroRecords: 'No columns'
            },
            scrollY: "40vh",
            scrollCollapse: true,
            columns: [
                {
                    "data": "name",
                    "title": "Column Name",
                    "width": "50%"
                },
                {
                    "data": "type",
                    "title": "Type",
                    "width": "50%"
                }
            ]
        })
    },
    renderViewMode: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.views-table'),
            data: _.filter(this.budgetViews.models, function (model) {
                if (model.get('companyId') !== -1) {
                    return model;
                }
            }),
            rowId: "cid",
            isHideSearch: true,
            paging: false,
            order: [1, 'asc'],
            language: {
                zeroRecords: 'No custom views exist. Press "Create View" to get started.'
            },
            scrollY: "40vh",
            scrollCollapse: true,
            onRowDoubleClick: _.bind(function (row) {
                this.editView(row.data());
            }, this),
            contextMenuOptions: {
                actions: [
                    {
                        name: 'Edit View',
                        isShown: _.bind(function (row) {
                            return true;
                        }, this),
                        onClick: _.bind(function (row) {
                            this.editView(row.data());
                        }, this)
                    },
                    {
                        name: 'Set as Default View',
                        isShown: _.bind(function (row) {
                            return !row.get('isDefault');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.setViewIsDefault(row.data());
                        }, this)
                    },
                    {
                        name: 'Delete View',
                        isDanger: true,
                        isShown: _.bind(function (row) {
                            return !row.get('isDefault');
                        }, this),
                        onClick: _.bind(function (row) {
                            this.deleteView(row.data());
                        }, this)
                    }
                ]
            },
            columns: [
                {
                    "data": null,
                    "title": '',
                    "orderable": false,
                    "render": _.bind(function (data, type, row) {
                        let icons = [];

                        if (row.get('isDefault')) {
                            icons.push("<i class='fal fa-crown fs-18' title='Default View'></i>");
                        }

                        return '<div class="d-flex justify-content-center">' + icons.join('') + '</div>';
                    }, this)
                },
                {
                    "data": "attributes.name",
                    "title": "View Name"
                },
                {
                    "data": "attributes.description",
                    "title": "View Description"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "160px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">';
                        if (!row.get('isDefault')) {
                            html += '<button type="button" class="btn btn-success set-default-view ht-30p wd-35p ml-1 fs-14" title="Set as Default View"><span class="fal fa-crown"></span></button>' +
                                '<button type="button" class="btn btn-info edit-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>' +
                                '<button type="button" class="btn btn-danger delete-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
                        } else {
                            html += '<button type="button" class="btn btn-info edit-view ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button></div>'
                        }
                        return html;
                    }, this)
                }
            ]
        });
    },
    setModalWidth: function (width) {
        this.options.maxWidth = width;
        this.$('.modal-dialog').animate({
            maxWidth: width
        }, 200);
    },
    createView: function () {
        this.budgetView = new PJQ.models.budget.BudgetView({
            name: "",
            description: "",
            isDefault: false
        });
        this.mode = this.modes.CREATE;
        this.template = this.budgetViews.models[0];
        this.render();
        this.setModalWidth(1000);
    },
    defaultViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.setViewIsDefault(view);
    },
    setViewIsDefault: function (view, isDefault = true) {
        let currentDefault = _.find(this.budgetViews.models, function (model) {
            return model.get('isDefault');
        }, this)

        if (currentDefault != null) {
            currentDefault.set('isDefault', false);
        }
        view.set('isDefault', isDefault);
        view.save(null, {
            success: _.bind(function () {
                this.dataTable.refresh();
                PJQ.notifications.notify.successNotify({
                    message: 'Default View Changed'
                });
            }, this)
        })
    },
    editViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.editView(view);
    },
    editView: function (view) {
        this.mode = this.modes.EDIT;
        this.budgetView = view;
        let fnRender = _.bind(function () {
            this.render();
            this.setModalWidth(1000);
        }, this)
        if (!this.budgetView.isNew() && !this.budgetView.isFetched) {
            this.budgetView.fetch({
                success: _.bind(function () {
                    fnRender();
                }, this)
            })
        } else {
            fnRender();
        }
    },
    viewBudgetViews: function () {
        if (this.budgetView != null && this.budgetView.hasChanged()) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveView()
                }, this),
                onDontSave: _.bind(function () {
                    this.budgetView.restore();
                    this.budgetView = null;
                    this.mode = this.modes.VIEW;
                    this.render();
                    this.setModalWidth(900);
                }, this)
            });
        } else {
            this.mode = this.modes.VIEW;
            this.render();
            this.setModalWidth(900);
        }

    },
    changeTemplate: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid');
        this.template = this.budgetViews.get(cid);
        this.render();
    },
    saveView: function () {
        if (this.validate()) {
            if (this.mode === this.modes.CREATE && this.template != null) {
                this.budgetView.columns = new PJQ.collections.budget.ViewColumns(this.template.columns.models);
                this.mode = this.modes.EDIT;
                this.render();
            } else {
                let isNew = this.budgetView.isNew();
                this.budgetView.save(null, {
                    success: _.bind(function () {
                        if (isNew) {
                            this.budgetViews.add(this.budgetView);
                        }
                        this.mode = this.modes.VIEW;
                        this.render();
                        this.setModalWidth(900);
                        PJQ.notifications.notify.successNotify({
                            message: "View successfully saved"
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.budgetView, this.budgetViews);
                        }
                    }, this)
                })
            }
        }
    },
    deleteViewClicked: function (e) {
        let target = $(e.currentTarget),
            view = this.dataTable.getRow(target.closest('tr')).data();
        this.deleteView(view);
    },
    deleteView: function (view) {
        this.budgetViews.remove(view);
        view.destroy({
            success: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(view, this.budgetViews);
                }
            }, this)
        });
        this.render();
    },
    columnsSorted: function () {
        this.budgetView.columns.models = _.map(this.$('.budget-view-column'), function (el) {
            return this.budgetView.columns.get($(el).data('cid'));
        }, this);

        this.render();
    },
    cancelColumnEdit: function () {
        let columnsChanged = false;
        _.each(this.budgetView.columns.models, function (model) {
            if (model.hasChanged()) {
                columnsChanged = true;
            }
        }, this)
        if (columnsChanged) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveView()
                }, this),
                onDontSave: _.bind(function () {
                    this.mode = this.modes.EDIT;
                    _.each(this.budgetView.columns.models, function (model) {
                        if (model.hasChanged()) {
                            model.restore();
                        }
                    }, this)
                    this.render();
                }, this)
            });
        } else {
            this.mode = this.modes.EDIT;
            this.render();
        }
    },
    deleteColumn: function (e) {
        e.stopPropagation();

        let $target = $(e.currentTarget),
            $item = $target.closest('.budget-list-item'),
            cid = $target.closest('.budget-list-item').data('cid');
        this.budgetView.columns.remove(cid);
        $item.remove();
    },
    editColumnClicked: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            column = this.budgetView.columns.get(cid);

        this.$('.selected-list-item').removeClass('selected-list-item');
        $target.addClass('selected-list-item');

        this.editColumn(column);
    },
    editColumn: function (column) {
        // this.$('.selected-list-item').removeClass('selected-list-item');
        // $target.addClass('selected-list-item');
        this.renderColumnConfiguration(column);
    },
    renderColumns: function () {
        this.renderSubTemplate(false, this.options.subTemplates.columns, this.$('.select-budget-columns'), {
            budgetView: this.budgetView
        }, _.bind(function (el) {
            this.columnsSortable = new PJQ.Sortable(this.$('.modal-content'), {
                items: '.budget-view-column',
                connectWith: '.budget-view-column',
                onStop: _.bind(function () {
                    this.columnsSorted();
                }, this)
            });
        }, this));
    },
    renderColumnConfiguration: function (column) {
        if (this.columnEditor) {
            this.columnEditor.remove()
        }

        let $editor = this.$('.column-config');
        if (column == null) {
            this.renderSubTemplate(true, this.options.subTemplates.columnEditorEmpty, $editor);
            return;
        }

        let $menuItem = $('.budget-list-item[data-cid="' + column.cid + '"] .column-name');
        this.columnEditor = new PJQ.views.budget.ViewColumnEditor({
            el: $editor,
            column: column,
            budgetView: this.budgetView,
            onNameChange: function () {
                $menuItem.text(column.get('name'));
            }
        })
    },
    createSourceColumn: function () {
        let column = new PJQ.models.budget.ViewColumn({
            type: PJQ.constants.budgetHelpers.columnTypes.SOURCE,
            name: '',
            format: null,
            options: {}
        });
        this.budgetView.columns.add(column);
        this.editColumn(column);
        this.renderColumns();
    },
    createCalculatedColumn: function () {
        let column = new PJQ.models.budget.ViewColumn({
            type: PJQ.constants.budgetHelpers.columnTypes.CALCULATED,
            name: '',
            format: PJQ.constants.budgetHelpers.columnFormats.MONEY,
            options: {}
        })
        this.budgetView.columns.add(column);
        this.editColumn(column);
        this.renderColumns();
    },
    validate: function () {
        let isValid = true;
        if (this.mode === this.modes.EDIT) {
            _.each(this.budgetView.columns.models, function (model) {
                let $menuItem = $('.budget-list-item[data-cid="' + model.cid + '"]');
                $menuItem.removeClass('budget-list-item-error')
                let markInvalid = _.bind(function (model) {
                    $menuItem.addClass('budget-list-item-error')
                }, this)
                if (model.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
                    _.each(model.calculations.models, function (calc, index) {
                        if (calc.get('source') == null) {
                            isValid = false;
                            markInvalid(model);
                        }

                        if (index > 0 && calc.get('operator') == null) {
                            isValid = false;
                            markInvalid(model);
                        }
                    }, this)
                } else if (model.get('source') == null) {
                    isValid = false;
                    markInvalid(model);
                }

                if (_.size(model.get('format')) === 0 &&
                    model.get('source') !== "GroupName" &&
                    model.get('source') !== "CostTypeId" &&
                    model.get('source') !== "Notes") {
                    isValid = false;
                    markInvalid(model);
                }
            }, this)
        }
        return isValid;
    }
});

PJQ.views.budget.ViewColumnEditor = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-column-editor'),
        subTemplates: {
            calculation: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'view-calculation')
        },
        onNameChange: null
    },
    events: {
        'keyup .view-name': 'nameChanged',
        'click .btn-add-calculation': 'addCalculation',
        'click .btn-remove-calculation': 'deleteCalculation'
    },
    beforeFirstRender: function () {
        this.column = this.options.column;
        this.budgetView = this.options.budgetView;

        this.isFetched = false;
        PJQ.app.session.fetchERPIntegration(_.bind(function (erp) {
            this.erpIntegration = erp;
            this.isFetched = true;
            this.render();
        }, this));
    },
    renderData: function () {
        return {
            column: this.column,
            isFetched: this.isFetched
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        new PJQ.Binder(this.$el, this.column, {
            watchElements: [
                'input'
            ]
        });

        if (_.size(this.column.get('name')) === 0) {
            this.$('.view-name').focus();
        }

        if (_.size(this.column.get('format')) === 0) {
            this.column.set('format', 'money');
        }

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-format'),
            defaultValue: this.column.get('format'),
            onChange: _.bind(function (value) {
                this.column.set('format', value);
            }, this)
        });

        if (this.column.get('type') === PJQ.constants.budgetHelpers.columnTypes.CALCULATED) {
            this.renderCalculations();
        } else if (this.column.get('type') === PJQ.constants.budgetHelpers.columnTypes.SOURCE) {
            let source = this.column.get('source'),
                choices = _.map(PJQ.constants.budgetHelpers.getColumnSources(), function (source) {
                    return {
                        id: source.source,
                        name: source.name + (source.isErp ? ('<span class="fs-10 pl-2 text-primary font-weight-bold">ERP</span>') : '')
                    };
                });
            new PJQ.inputs.Selectpicker({
                el: this.$('.select-source'),
                defaultValue: source,
                choices: choices,
                onChange: _.bind(function (value) {
                    let colSource = _.find(PJQ.constants.budgetHelpers.getColumnSources(), function (src) {
                        return src.source === value;
                    });
                    if (_.size(this.column.get('name')) === 0) {
                        this.column.set('name', colSource.name);
                        this.$('.view-name', colSource.name);
                        this.nameChanged();
                    }

                    this.column.set({
                        source: value,
                        format: colSource.format,
                        options: {}
                    });
                    this.render();
                }, this)
            });

            new PJQ.inputs.Selectpicker({
                el: this.$('.source-status-filter'),
                noneSelectedText: 'No Status Filters',
                isMultiple: true,
                defaultValue: this.column.get('options') != null ? _.map(this.column.get('options').statuses, function (value) {
                    return value.toString();
                }) : null,
                onChange: _.bind(function (value) {
                    let statuses = _.map(value, function (id) {
                            return parseInt(id);
                        }, this),
                        options = {
                            "statuses": statuses
                        }
                    this.column.set('options', options);
                }, this),
                title: 'No Filters'
            });
        }
    },
    nameChanged: function () {
        if (typeof this.options.onNameChange === 'function') {
            this.options.onNameChange(this.column);
        }
    },
    renderCalculations: function () {
        this.$('.calculation-container').empty();

        if (_.size(this.column.calculations.models) === 0) {
            this.addCalculation();
        } else {
            _.each(this.column.calculations.models, function (model) {
                this.renderCalculation(model);
            }, this)
        }
    },
    renderCalculation: function (calculation) {
        this.renderSubTemplate(true, this.options.subTemplates.calculation, this.$('.calculation-container'), {
            model: calculation
        }, _.bind(function (el) {
            let $calc = $(el);
            new PJQ.Binder($calc, calculation, {
                watchElements: [
                    'input'
                ]
            });

            new PJQ.inputs.Selectpicker({
                el: $calc.find('.operator'),
                noneSelectedText: null,
                defaultValue: calculation.get('operator'),
                onChange: _.bind(function (value) {
                    calculation.set('operator', value);
                }, this),
                title: 'Select Operator'
            });

            let choices = _.map(PJQ.constants.budgetHelpers.getColumnSources(), function (source) {
                return {
                    id: source.source,
                    name: source.name + (source.isErp ? ('<span class="fs-10 pl-2 text-primary font-weight-bold">ERP</span>') : '')
                };
            });
            new PJQ.inputs.Selectpicker({
                el: $calc.find('.select-source'),
                noneSelectedText: null,
                choices: choices,
                defaultValue: calculation.get('source'),
                onChange: _.bind(function (value) {
                    calculation.set('source', value);
                    this.render();
                }, this),
                title: 'Select Column'
            });

            if (calculation.get('source') === "PrimeContractValues" || calculation.get('source') === "PrimeContractChangeOrderValues"
                || calculation.get('source') === "CommitmentValues" || calculation.get('source') === "CommitmentChangeOrderValues"
                || calculation.get('source') === "DirectCostValues" || calculation.get('source') === "PayableInvoiceValues"
                || calculation.get('source') === "ReceivableInvoiceValues") {
                new PJQ.inputs.Selectpicker({
                    el: $calc.find('.select-source-filter'),
                    noneSelectedText: 'No Status Filters',
                    isMultiple: true,
                    defaultValue: calculation.get('options') != null ? _.map(calculation.get('options').statuses, function (value) {
                        return value.toString();
                    }) : null,
                    onChange: _.bind(function (value) {
                        let statuses = _.map(value, function (id) {
                                return parseInt(id);
                            }, this),
                            options = {
                                "statuses": statuses
                            }
                        calculation.set('options', options);
                    }, this),
                    title: 'No Filters'
                });
            }

        }, this));
    },
    addCalculation: function () {
        let calculation = new PJQ.models.budget.ViewColumnCalculation({
            source: null
        });
        if (_.size(this.column.calculations.models) === 0) {
            let calculations = [calculation];
            calculations.push(new PJQ.models.budget.ViewColumnCalculation({
                source: null
            }));

            this.column.calculations.add(calculations);
            this.renderCalculations();
        } else {
            this.column.calculations.add(calculation);
            this.renderCalculations();
        }
    },
    deleteCalculation: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            calculation = this.column.calculations.get(cid);

        this.column.calculations.remove(calculation);
        this.renderCalculations();
    }
});
